import { render, staticRenderFns } from "./TermsComponent.vue?vue&type=template&id=756e949a&scoped=true"
import script from "./TermsComponent.vue?vue&type=script&lang=js"
export * from "./TermsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756e949a",
  null
  
)

export default component.exports